import React from 'react';
import clsx from 'clsx';
import { Image, T } from '@colonist/ui';
import styles from './PageTabItem.module.scss';
export const PageTabItem = ({ tab, isActive, isDisabled, onClick, hideText })=>{
    const handleClick = (event)=>{
        if (isDisabled) {
            event.preventDefault();
            return;
        }
        onClick();
    };
    return /*#__PURE__*/ React.createElement("a", {
        href: tab.href,
        "aria-disabled": isDisabled,
        className: clsx(styles.pageTabItem, 'm-no-drag', {
            [styles.active]: isActive,
            [styles.centered]: hideText,
            [styles.hideText]: hideText,
            [styles.disabled]: isDisabled
        }),
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(Image, {
        className: clsx(styles.icon, 'm-no-drag'),
        image: {
            src: tab.icon,
            alt: tab.label
        }
    }), /*#__PURE__*/ React.createElement("span", {
        className: clsx(styles.label, 'm-no-drag')
    }, /*#__PURE__*/ React.createElement(T, {
        id: tab.label
    })));
};
